<template>
  <div class="grid-basic-config">
    <div style="padding: 12px 8px 8px 8px;">
      <el-form ref="form" :model="gridConfig" label-width="126px" size="mini" label-position="left">
        <div style="width: 48%; float: left;">
          <el-form-item label="所属站点*">
            <el-select v-model="gridConfig.peWebSite.id">
              <el-option
                v-for="site in webSites" :key="site.id" :value="site.id" :label="site.name">
              </el-option>
            </el-select>
            (仅备注作用)
          </el-form-item>
          <el-form-item label="grid id*">
            <el-input v-model.trim="gridConfig.id"></el-input>
          </el-form-item>
          <el-form-item label="grid 标题*">
            <el-input v-model.trim="gridConfig.title"></el-input>
          </el-form-item>
          <el-form-item label="entityClass">
            <el-input v-model.trim="gridConfig.entityClass"></el-input>
          </el-form-item>
          <el-form-item label="查询类型">
            <el-radio-group v-model="gridConfig.listType">
              <el-radio border :label="'1'">sql查询</el-radio>
              <el-radio border :label="'0'">dc查询</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="图表配置">
            <el-select v-model="gridConfig.peChart.id" filterable clearable>
              <el-option
                v-for="chart in chartList" :key="chart.id" :value="chart.id" :label="chart.name">
              </el-option>
            </el-select>
            (不选择则不开启图表功能)
          </el-form-item>
        </div>
        <div style="width: 48%; float: left; margin-left: 20px">
          <el-form-item label="grid功能">
            <el-switch v-model="gridConfig.canSearch" :active-value="'1'" :inactive-value="'0'"></el-switch>搜索&nbsp;&nbsp;&nbsp;
            <el-switch v-model="gridConfig.firstSearch" :active-value="'1'" :inactive-value="'0'"></el-switch>预搜索&nbsp;&nbsp;&nbsp;
            <el-switch v-model="gridConfig.canProjections" :active-value="'1'" :inactive-value="'0'"></el-switch>dc投影&nbsp;&nbsp;&nbsp;
            <el-switch v-model="gridConfig.canCheckedAll" :active-value="'1'" :inactive-value="'0'"></el-switch>选择全部数据
            <el-switch v-model="gridConfig.flagShowAllSearch" :active-value="'1'" :inactive-value="'0'"></el-switch>展示全部检索框
          </el-form-item>
          <el-form-item label="是否有效">
            <el-switch v-model="gridConfig.enumConstByFlagActive.id" :active-value="'4028809c1d625bcf011d66fd0dda0006'" :inactive-value="'4028809c1d625bcf011d66fdb39f0007'"></el-switch>
          </el-form-item>
          <el-form-item label="添加框模式">
            <el-radio-group v-model="gridConfig.addMode">
              <el-radio border :label="'dialog'">弹出框</el-radio>
              <el-radio border :label="'drawer'">抽屉</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="添加框自定义组件">
            <el-input v-model.trim="gridConfig.addCmpName"></el-input>
          </el-form-item>
          <el-form-item label="sql类型">
            <el-radio-group v-model="gridConfig.listFunction">
              <el-radio border :label="'0'">普通</el-radio>
              <el-radio border :label="'1'">高效</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div style="clear: both;"></div>
        <el-form-item label="sql">
          <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 15}" v-model.trim="gridConfig.sql"></el-input>
        </el-form-item>
        <el-form-item label="dc">
          <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 15}" v-model.trim="gridConfig.dc"></el-input>
        </el-form-item>
        <el-form-item label="importNote">
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 15}" v-model.trim="gridConfig.importNote"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-top: 6px; text-align: center;">
      <el-button @click="saveGridConfig" type="primary" size="mini">保存</el-button>
    </div>
  </div>
</template>

<script>
  import util from '../../libs/util'
  export default {
    name: 'grid-basic-config',
    props: {
      gridConfig: {
        type: Object,
        require: true,
        default() {
          return {}
        }
      },
      webSites: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        chartList: []
      }
    },
    created() {
      this.loadChartList()
    },
    methods: {
      loadChartList() {
        util.ajax.post('/superAdmin/chartManage/chartSelectData').then((res) => {
          if (res.data.meta.errCode === 0) {
            this.chartList = res.data.data
          } else {
            this.$notify.info({title: '提示', message: '获取图表数据失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取图表数据失败：'})
          console.error(err)
        })
      },
      saveGridConfig() {
        if (!this.checkBeforeSave()) {
          return
        }
        util.ajax.post('/superAdmin/gridManage/saveGridConfig', this.gridConfig).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '保存成功'})
          } else {
            this.$notify.warning({title: '警告', message: '保存失败'})
          }
        }).catch((err) => {
          this.$notify.warning({title: '警告', message: '保存失败'})
          console.error(err)
        })
      },
      checkBeforeSave() {
        if (!this.gridConfig.id) {
          this.$notify.warning({title: '警告', message: 'grid id不能为空！'})
          return false
        }
        if (!this.gridConfig.title) {
          this.$notify.warning({title: '警告', message: 'grid 标题不能为空！'})
          return false
        }
        if (!this.gridConfig.peWebSite || !this.gridConfig.peWebSite.id) {
          this.$notify.warning({title: '警告', message: '请选择所属站点！'})
          return false
        }
        return true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/super-admin/grid-manage/grid-basic-config.vue